// extracted by mini-css-extract-plugin
export default {"grid":"ClientProject_grid__S2Cid","block":"ClientProject_block__zOMeI","cover":"ClientProject_cover__fCiBu","logo":"ClientProject_logo__y1bsu","item":"ClientProject_item__Sk+Rv"};